
export const SET_OFFERS_FILTER = "SET_OFFERS";
export const SET_OFFERS_FILTER_MUTATION = "SET_OFFERS_MUTATION";

export default {
    namespace: "offersModule",
    state: () => ({
        /**
         * List offers for filter (Selection options)
         */
        filters: [],
    }),

    actions: {
        [SET_OFFERS_FILTER](context, payload) {
            context.commit(SET_OFFERS_FILTER_MUTATION, payload);
        }
    },

    mutations: {
        [SET_OFFERS_FILTER_MUTATION](state, payload = []) {
            state.filters = payload;
        }
    },

    getters: {
        offersFilter: (state) => state.filters,
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/offerModule.js